<template>
  <div
    id="layout"
    class="antialiased bg-[#012526] text-white font-sans border-b border-[#033A3D]"
  >
    <header ref="header" :style="headerStyle">
      <ErrorBoundary>
        <client-only>
          <Notifications />
        </client-only>
        <NavbarDarkMinimal />
      </ErrorBoundary>
      <slot name="banner" />
    </header>

    <ErrorBoundary>
      <main>
        <PageLoader />
        <slot />
      </main>
    </ErrorBoundary>
  </div>
</template>
<script lang="ts" setup>
const { headerStyle } = useAutoHideHeader(useTemplateRef('header'))

useLayoutHead()
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
#layout {
  box-sizing: border-box;
}

header {
  @apply sticky top-0 z-20;
  transition: top 0.3s ease;
}

main {
  /*
    71px - header height
  */
  min-height: calc(100vh - 71px);
  position: relative;
}
</style>

<style>
.Toastify__toast-container {
  max-width: 480px;
  --toastify-toast-width: max-content;
}
</style>
